/**
 * This file is used to configure the app
 *
 * If you have the "Cannot find name 'defineAppConfig'.ts(2304)" error
 * update the root tsconfig.json file to include the following:
 *
 *  "extends": "./.app/.nuxt/tsconfig.json"
 *
 */

export default defineAppConfig({
    defaultNavigationItems: [
        {
            name: 'Unterricht',
            icon: { name: 'ph:graduation-cap', class: 'w-5 h-5' },
            to: '/classes',
        },
        {
            name: 'Portfolio',
            icon: { name: 'ph:suitcase-simple', class: 'w-5 h-5' },
            to: '/portfolio',
        },
        {
            name: 'Profil',
            icon: { name: 'ph:user', class: 'w-5 h-5' },
            to: '/profile',
        },
        {
            name: 'Divider',
            divider: true,
        },
        {
            name: 'Schulgeldvorschreibung',
            icon: { name: 'ph:wallet', class: 'w-5 h-5' },
            to: '/invoices',
        },
        // {
        //     name: 'Posteingang',
        //     icon: { name: 'ph:tray', class: 'w-5 h-5' },
        //     to: '/inbox',
        // },
        // {
        //     name: 'Vorschreibung',
        //     icon: { name: 'ph:hand-coins', class: 'w-5 h-5' },
        //     to: '/prescription',
        // },
        // {
        //     name: 'Abrechnung',
        //     icon: { name: 'ph:receipt', class: 'w-5 h-5' },
        //     to: '/billing',
        // },
        {
            name: 'Divider',
            divider: true,
        },
        {
            id: 'musikschule',
            name: 'Musikschule',
            component: {
                name: 'CollapseNavigationExternalLink',
                props: {
                    text: 'Musikschule',
                    icon: { name: 'ph:buildings', class: 'w-5 h-5' },
                    link: 'https://musikum.at/de/musikschulen',
                },
            },
        },
        {
            id: 'uebeleitfaden',
            name: 'Übeleitfaden',
            component: {
                name: 'CollapseNavigationPdfGroup',
                props: {
                    text: 'Übeleitfaden',
                    icon: { name: 'ph:book-open-text', class: 'w-5 h-5' },
                    links: [
                        {
                            text: 'Übeleitfaden für Eltern',
                            link: '/api/uebeleitfaden/eltern',
                            icon: { name: 'ph:file-pdf', class: 'w-4 h-4' },
                        },
                        {
                            text: 'Übeleitfaden für Schüler:innen',
                            link: '/api/uebeleitfaden/schueler',
                            icon: { name: 'ph:file-pdf', class: 'w-4 h-4' },
                        },
                    ],
                },
            },
        },
        {
            name: 'Veranstaltungen',
            component: {
                name: 'CollapseNavigationExternalLink',
                props: {
                    text: 'Veranstaltungen',
                    icon: { name: 'ph:calendar-blank', class: 'w-5 h-5' },
                    link: 'https://musikum.at/de/veranstaltungen-news/veranstaltungen',
                },
            },
        },
        {
            name: 'News',
            component: {
                name: 'CollapseNavigationExternalLink',
                props: {
                    text: 'News',
                    icon: { name: 'ph:newspaper', class: 'w-5 h-5' },
                    link: 'https://musikum.at/de/veranstaltungen-news/news',
                },
            },
        },
        {
            name: 'Gehörbildungs App',
            component: {
                name: 'CollapseNavigationExternalLink',
                props: {
                    text: 'Gehörbildungs App',
                    icon: { name: 'ph:ear', class: 'w-5 h-5' },
                    link: 'https://musikum.at/de/services/services-fuer-schuelerinnen-schueler/online-gehoertraining',
                },
            },
        },
        {
            name: 'Datenschutzerklärung',
            component: {
                name: 'CollapseNavigationExternalLink',
                props: {
                    text: 'Datenschutzerklärung',
                    icon: { name: 'ph:lock', class: 'w-5 h-5' },
                    link: 'https://musikum.at/de/datenschutz',
                },
            },
            position: 'end',
        },
        {
            name: 'Impressum',
            component: {
                name: 'CollapseNavigationExternalLink',
                props: {
                    text: 'Impressum',
                    icon: { name: 'ph:info', class: 'w-5 h-5' },
                    link: 'https://musikum.at/de/impressum',
                },
            },
            position: 'end',
        },
        {
            name: 'Einstellungen',
            icon: { name: 'ph:gear-six', class: 'w-5 h-5' },
            to: '/settings',
            position: 'end',
        },
    ],
    tairo: {
        title: 'Musikum Portal',
        error: {
            logo: {
                component: 'MusikumLogo',
                props: {
                    class: 'text-primary-500 mx-auto h-40 p-6',
                },
            },
        },
        panels: [],
        collapse: {
            circularMenu: {
                enabled: false,
                tools: [],
            },
            toolbar: {
                enabled: true,
                showTitle: true,
                showNavBurger: true,
                tools: [
                    {
                        component: 'HelpBubble',
                    },
                    {
                        component: 'ThemeToggle',
                    },
                    {
                        component: 'ToolbarAccountMenu',
                    },
                ],
            },
            navigation: {
                enabled: true,
                header: {
                    component: 'CollapseNavigationHeader',
                },
                logo: {
                    component: 'MusikumLogo',
                    props: {
                        class: 'text-primary-500 mx-auto h-40 p-6',
                    },
                },
                footer: {
                    component: '',
                },
                items: [],
            },
        },
    },
})
